import { DEFAULT_SPEAKER_SCRIPT_CONFIG } from "./scriptOps.js";
import { estimateSeconds } from "./scriptEstimate.js";
const ROLE_WEIGHT = {
    cover: 0.75,
    agenda: 0.7,
    section: 0.85,
    summary: 0.85,
    cta: 0.85,
    closing: 0.85,
    quote: 1.15,
    data: 1.15,
    comparison: 1.05,
    content: 1.0,
};
function roleWeight(slide) {
    const role = (slide.outlineRole ?? "content").toLowerCase();
    return ROLE_WEIGHT[role] ?? 1.0;
}
/**
 * Ripartisce `totalTargetMinutes` tra le slide per peso ruolo.
 * Slide con `speakerScript.targetSeconds` esplicito sono escluse (budget fisso).
 */
export function allocateBudget(deck) {
    const config = deck.speakerScriptConfig ?? DEFAULT_SPEAKER_SCRIPT_CONFIG;
    const totalSeconds = (config.totalTargetMinutes ?? 0) * 60;
    const result = new Map();
    if (totalSeconds <= 0 || !deck.slides.length) {
        for (const slide of deck.slides) {
            const fixed = slide.speakerScript?.targetSeconds;
            if (typeof fixed === "number" && fixed > 0)
                result.set(slide.id, fixed);
        }
        return result;
    }
    let fixedTotal = 0;
    const flexible = [];
    for (const slide of deck.slides) {
        const fixed = slide.speakerScript?.targetSeconds;
        if (typeof fixed === "number" && fixed > 0) {
            result.set(slide.id, fixed);
            fixedTotal += fixed;
        }
        else {
            flexible.push(slide);
        }
    }
    const remaining = Math.max(0, totalSeconds - fixedTotal);
    if (!flexible.length)
        return result;
    const weightSum = flexible.reduce((sum, s) => sum + roleWeight(s), 0);
    if (weightSum <= 0) {
        const each = Math.round(remaining / flexible.length);
        for (const slide of flexible)
            result.set(slide.id, each);
        return result;
    }
    for (const slide of flexible) {
        const share = (roleWeight(slide) / weightSum) * remaining;
        result.set(slide.id, Math.max(5, Math.round(share)));
    }
    return result;
}
/** Total estimated seconds across all slides (live word count). */
export function totalEstimatedSeconds(deck) {
    const wpm = deck.speakerScriptConfig?.wordsPerMinute ?? 140;
    return deck.slides.reduce((sum, slide) => {
        const text = slide.speakerScript?.text ?? "";
        return sum + estimateSeconds(text, wpm);
    }, 0);
}
